// load all static images
// eslint-disable-next-line no-undef
require.context("../images", true, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/); 